export default __webpack_public_path__ + "static/media/ChangePswIcon.bacae9db.svg";